import { isIE } from 'utils/browser';

type NavigatorWithIE = Navigator & {
  msSaveOrOpenBlob?: (blob: Blob, defaultName?: string) => boolean;
};

export function initiatePrinting({
  windowReference,
  blob,
  filename
}: {
  windowReference: Window | null;
  blob: Blob;
  filename: string;
}) {
  const navigator = window.navigator as NavigatorWithIE;
  // in IE, use proprietary API to trigger file download
  // for everything else, create a link with a data url and then click on it
  // source: http://stackoverflow.com/a/33542499
  // source: http://stackoverflow.com/questions/24007073/open-links-made-by-createobjecturl-in-ie11
  if (isIE() && navigator.msSaveOrOpenBlob) {
    // for IE
    navigator.msSaveOrOpenBlob(blob, filename);

    return;
  }
  if (windowReference) {
    const file_url = URL.createObjectURL(blob);
    windowReference.location = file_url;
  } else {
    throw new Error('Could not open window');
  }
}
